// Boutons proposés par le widget « Boutons d'action » (libellés i18n, cibles du router) ; droits vérifiés par le tableau de bord
export const DASHBOARD_ACTIONS = [
  { key: 'create', icon: 'edit', primary: true, label: 'dash.overview.actions.create_post', target: { name: 'postCreator' } },
  { key: 'planner', icon: 'date_range', label: 'dash.overview.actions.planner', target: { name: 'posts2', tab: 'planner' } },
  { key: 'inbox', icon: 'question_answer', label: 'dash.overview.actions.inbox', target: { name: 'moderation' } },
  { key: 'reporting', icon: 'insert_chart', label: 'dash.overview.actions.reporting', target: { name: 'reporting' } },
  { key: 'pages', icon: 'pages', label: 'dash.overview.actions.manage_pages', target: { name: 'pages' } },
  { key: 'sources', icon: 'rss_feed', label: 'dash.overview.actions.sources', target: { name: 'sources' } },
  { key: 'presence', icon: 'location_on', label: 'dash.overview.actions.presence', target: { name: 'presence-management' } }
]

// Boutons qui s'appliquent à des pages (pages du bouton, sinon celles du tableau de bord)
export const PAGE_ACTIONS = ['create', 'planner', 'inbox', 'reporting']
